import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const useArticleClassifications = (
  props = { limit: 999 },
  swrOptions
) => {
  return useCustomSWR(`/articleClassifications?${stringify(props)}`, swrOptions)
}
